import createStorage from '@/storage';
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import Shop from '@/shop';

const Store = createStorage({ name: 'common-reviews-products' });

/*
 * @class
 * RecentlyViewed
 */
var RecentlyViewed = function() {
  var self = this;

  window.addEventListener('load', function() {
    self._initStoreProduct();
  });
};

/**
 *
 * Забираем с кеша массив просмотренных товаров
 * @method
 *
 * @return {void}
 */
RecentlyViewed.prototype._initStoreProduct = function() {
  var self = this;

  Store.getItem('common-reviews-products')
    .then(function(ids) {
      if (~document.location.pathname.indexOf('/product')) {
        const preparedData = self._prepareStoreProduct(ids);

        return self._setStoreProduct(preparedData);
      }

      return false;
    });
};

/**
 *  Подготавливаем массив для установки в кеш
 * @method
 *
 * @param {Array} reviews_ids - Данные полученные с кеша
 *
 * @return {Array} - Подготовленный массив
 */
RecentlyViewed.prototype._prepareStoreProduct = function(reviews_ids) {
  var product_id = +Shop.config.getProductId();
  var reviews_items = reviews_ids || [];
  var indexProductId = reviews_items.indexOf(product_id);

  if (~indexProductId) {
    reviews_items.splice(indexProductId, 1);
  }

  reviews_items.unshift(product_id);

  if (reviews_items.length > 30) {
    reviews_items.pop();
  }

  return reviews_items;
};

/**
 *  Утаскиваем переработанный массив в кеш
 * @method
 *
 * @param {Array} prepare_ids - Переработанный массив
 *
 * @return {void}
 */
RecentlyViewed.prototype._setStoreProduct = function(prepare_ids) {
  Store.setItem('common-reviews-products', prepare_ids);
};

export default deferredSingletonExport(_Singleton(RecentlyViewed), RecentlyViewed);
